import React from "react";

import { ReactComponent as NoProfilePhotoBig } from "../../assets/icons/noProfilePhoto.svg";
import { ReactComponent as NoProfilePhotoSmall } from "../../assets/icons/noProfilePhotoHeader2.svg";

const DefaultProfilePhoto = ({
  size,
  width,
  height,
  className,
  style,
  header,
  ...rest
}) => {
  const Icon = header ? NoProfilePhotoSmall : NoProfilePhotoBig;

  return (
    <Icon
      width={width ?? size}
      height={height ?? size}
      className={className}
      style={style}
      {...rest}
    />
  );
};

export default DefaultProfilePhoto;
